import { render } from "./FooterBar.vue?vue&type=template&id=f906bf10&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=f906bf10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f906bf10"],['__file',"src/components/FooterBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f906bf10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f906bf10', __exports__)) {
    api.reload('f906bf10', __exports__)
  }
  
  module.hot.accept("./FooterBar.vue?vue&type=template&id=f906bf10&scoped=true", () => {
    api.rerender('f906bf10', render)
  })

}


export default __exports__